var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChartDonut',{class:[
    _vm.$style.chart,
    {[_vm.$style.chartHalfSize]: _vm.halfSizeChart}
  ],attrs:{"labels":_vm.labels,"legendPosition":_vm.legendPosition,"options":_vm.options,"series":_vm.series,"showLegend":_vm.showLegend},on:{"selectDataPoint":_vm.handleSelectDataPoint}})
}
var staticRenderFns = []

export { render, staticRenderFns }